// removed by extract-text-webpack-plugin
module.exports = {"container":"_3HmaAaFLxG0WOZAyXv3cYM"};